import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutService } from '@/core/layout/service/layout.service';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [CommonModule, RouterModule, ButtonModule],
    template: ` <div class="layout-footer">
        <img [src]="'/images/logo/footer' + (layoutService.isDarkTheme() ? '-dark' : '') + '.png'" alt="footer-logo" />
    </div>`
})
export class AppFooterComponent {
    layoutService: LayoutService = inject(LayoutService);
}
